var map = {
	"./about-us.svg": 754,
	"./betting-icon.svg": 755,
	"./bonus.svg": 756,
	"./coin.svg": 757,
	"./contact-us.svg": 758,
	"./download-app.svg": 759,
	"./edit-btn.svg": 760,
	"./feedback.svg": 761,
	"./global.svg": 762,
	"./info-centre.svg": 763,
	"./instant-rebate.svg": 764,
	"./mall-icon.svg": 765,
	"./message.svg": 766,
	"./personal-info-edit.svg": 767,
	"./r77-coin.svg": 768,
	"./r77-rewards.svg": 769,
	"./redemption-icon.svg": 770,
	"./referral.svg": 771,
	"./resp-gaming.svg": 772,
	"./security.svg": 773,
	"./transaction-icon.svg": 774,
	"./vip-icon.svg": 775,
	"./wallet-icon.svg": 776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;